import { render, staticRenderFns } from "./VoiceControl.vue?vue&type=template&id=62d342cc&scoped=true"
import script from "./VoiceControl.vue?vue&type=script&lang=js"
export * from "./VoiceControl.vue?vue&type=script&lang=js"
import style0 from "./VoiceControl.vue?vue&type=style&index=0&id=62d342cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d342cc",
  null
  
)

export default component.exports